import { Stack } from "@mui/material";
import type { FC, PropsWithChildren } from "react";
import "./Actions.scss";

const Actions: FC<PropsWithChildren<{ alignToBottom?: boolean }>> = ({ children, alignToBottom }) => (
  <Stack
    direction="row"
    className="actions"
    spacing={3}
    sx={{
      alignItems: alignToBottom ? "flex-end" : undefined,
    }}
  >
    {children}
  </Stack>
);

export default Actions;
